import { Permission } from '@cims-online/shared'
import { EditRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import {
  NonUserEmail,
  useNonUserEmailsTableContext,
} from '../../../../NonUserEmailsTableContext'
import {
  EditNonUserEmailModalBody,
  EditNonUserEmailModalValues,
} from './components/EditNonUserEmailBody'
import { useEditNonUserEmailMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleEditNotification } from 'hooks/notificationHandler'

export function useEditOptions(): EditRowActionOptions<
  NonUserEmail,
  EditNonUserEmailModalValues
> {
  const { refetch } = useNonUserEmailsTableContext()
  const [editNonUserEmail] = useEditNonUserEmailMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      editNonUserEmail: {
        nonUserEmail: { label, address },
      },
    }) => simpleEditNotification(label ?? address),
  })
  return {
    permission: Permission.EditNonUserEmail,
    modal: {
      type: 'simple',
      recordName: ({ label }) => label ?? 'Non User Email',
      body: <EditNonUserEmailModalBody />,
      initialValues: ({ label, address, description }) => {
        return { label, address, description }
      },
      onOk: async (current, { label, address, description }) => {
        if (
          (current.label ?? '') !== (label ?? '') ||
          current.address !== address ||
          current.description !== description
        ) {
          await editNonUserEmail({
            variables: {
              editNonUserEmailInput: {
                id: current.id,
                label,
                address,
                description,
              },
            },
          })
          refetch()
        }
      },
    },
  }
}
